import React, { useState } from 'react';

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt?: string;
  className?: string;
  fallbackInitial?: string;
}

function Image({
  src,
  alt = "Image Name",
  className = "",
  fallbackInitial,
  fetchPriority,
  ...props
}: ImageProps & { fetchPriority?: 'high' | 'low' | 'auto' }) {
  const [hasError, setHasError] = useState(false);
  const [imgLoaded, setImgLoaded] = useState(false);

  const handleError = () => {
    setHasError(true);
  };

  const handleLoad = () => {
    setImgLoaded(true);
  };

  // Show initial fallback if image fails or src is empty/invalid
  if (hasError || !src || src === '/default-avatar.png') {
    const initial = fallbackInitial || alt?.charAt(0)?.toUpperCase() || '?';
    return (
      <div
        className={`flex items-center justify-center bg-gradient-to-br from-primary/60 to-primary text-white font-bold ${className}`}
        style={{ fontSize: '1.25rem' }}
        aria-label={alt}
      >
        {initial}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={handleError}
      onLoad={handleLoad}
      {...(fetchPriority ? { fetchpriority: fetchPriority } : {})}
      {...props}
    />
  );
}

export default Image;